import React from 'react';
import SeoData from '../../Dumbo/_partials/SeoData';
import { FullViewProps } from '../types';
import Image from './Image';

const IMAGE_WRAPPER_SEO_PROPS = {
  typeof: 'ImageObject',
  vocab: 'https://schema.org/',
};

const IMAGE_PROPS = {
  // SEO
  property: 'contentUrl',
  // react doesn't know about this yet...
  fetchPriority: 'high',
} as any;

/** Wrapped version of FullImage that adds SEO data only needed
 *  for full deviations */
export const ImageDeviation: React.FC<FullViewProps> = ({
  deviation,
  ...props
}) => {
  return (
    <Image
      source={deviation}
      allowFullviewSrcsetForPngs={deviation.isPublished}
      altText={deviation.title}
      wrapperProps={IMAGE_WRAPPER_SEO_PROPS}
      imageProps={IMAGE_PROPS}
      afterImage={<SeoData deviation={deviation} />}
      {...props}
    />
  );
};
ImageDeviation.displayName = 'ImageDeviation';

export default ImageDeviation;
